"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _store = require("@/api/store");
var _logistics = require("@/api/logistics");
var _public = require("@/libs/public");
var _marketing = require("@/api/marketing");
var _creatTemplates = _interopRequireDefault(require("@/views/systemSetting/deliverGoods/freightSet/creatTemplates"));
var _validate = require("@/utils/validate");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var defaultObj = {
  image: '',
  images: '',
  imagess: [],
  title: '',
  info: '',
  num: 1,
  unitName: '',
  sort: 0,
  giveIntegral: 0,
  ficti: 0,
  isShow: false,
  tempId: '',
  attrValue: [{
    image: '',
    price: 0,
    cost: 0,
    otPrice: 0,
    stock: 0,
    quota: 1,
    barCode: '',
    weight: 0,
    volume: 0
  }],
  attr: [],
  selectRule: '',
  content: '',
  specType: false,
  id: 0,
  timeId: 1,
  startTime: '',
  stopTime: '',
  timeVal: [],
  status: 0
};
var objTitle = {
  price: {
    title: '秒杀价'
  },
  cost: {
    title: '成本价'
  },
  otPrice: {
    title: '原价'
  },
  stock: {
    title: '库存'
  },
  quota: {
    title: "限量"
  },
  barCode: {
    title: '商品编号'
  },
  weight: {
    title: '重量（KG）'
  },
  volume: {
    title: '体积(m³)'
  }
};
var _default = exports.default = {
  name: "creatSeckill",
  components: {
    CreatTemplates: _creatTemplates.default,
    Tinymce: _index.default
  },
  data: function data() {
    return {
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < new Date().setTime(new Date().getTime() - 3600 * 1000 * 24);
        }
      },
      props2: {
        children: 'child',
        label: 'name',
        value: 'id',
        multiple: true,
        emitPath: false
      },
      grid2: {
        xl: 8,
        lg: 10,
        md: 12,
        sm: 24,
        xs: 24
      },
      currentTab: 0,
      formThead: Object.assign({}, objTitle),
      formValidate: Object.assign({}, defaultObj),
      loading: false,
      fullscreenLoading: false,
      merCateList: [],
      // 商户分类筛选
      shippingList: [],
      // 运费模板
      seckillTime: [],
      ruleValidate: {
        productId: [{
          required: true,
          message: '请选择商品',
          trigger: 'change'
        }],
        title: [{
          required: true,
          message: '请输入商品标题',
          trigger: 'blur'
        }],
        attrValue: [{
          required: true,
          message: '请选择商品属相',
          trigger: 'change',
          type: 'array',
          min: '1'
        }],
        num: [{
          required: true,
          message: '请输入活动次数',
          trigger: 'blur'
        }],
        unitName: [{
          required: true,
          message: '请输入单位',
          trigger: 'blur'
        }],
        info: [{
          required: true,
          message: '请输入秒杀商品简介',
          trigger: 'blur'
        }],
        tempId: [{
          required: true,
          message: '请选择运费模板',
          trigger: 'change'
        }],
        timeId: [{
          required: true,
          message: '请选择活动时间',
          trigger: 'change'
        }],
        image: [{
          required: true,
          message: '请上传商品图',
          trigger: 'change'
        }],
        imagess: [{
          required: true,
          message: '请上传商品轮播图',
          type: 'array',
          trigger: 'change'
        }],
        specType: [{
          required: true,
          message: '请选择商品规格',
          trigger: 'change'
        }],
        timeVal: [{
          required: true,
          message: '请选择活动日期',
          trigger: 'change',
          type: 'array'
        }]
      },
      manyTabDate: {},
      manyTabTit: {},
      attrInfo: {},
      tempRoute: {},
      multipleSelection: [],
      productId: 0,
      OneattrValue: [Object.assign({}, defaultObj.attrValue[0])],
      // 单规格
      ManyAttrValue: [Object.assign({}, defaultObj.attrValue[0])] // 多规格
    };
  },
  computed: {
    attrValue: function attrValue() {
      var obj = Object.assign({}, defaultObj.attrValue[0]);
      delete obj.image;
      return obj;
    }
  },
  created: function created() {
    this.$watch('formValidate.attr', this.watCh);
    this.tempRoute = Object.assign({}, this.$route);
  },
  mounted: function mounted() {
    var _this2 = this;
    (0, _public.getSeckillList)(1).then(function (res) {
      _this2.seckillTime = res.list;
    });
    this.formValidate.imagess = [];
    if (this.$route.params.id) {
      this.setTagsViewTitle();
      this.getInfo();
      this.currentTab = 1;
    }
    this.getShippingList();
    this.getCategorySelect();
  },
  methods: {
    watCh: function watCh(val) {
      var tmp = {};
      var tmpTab = {};
      this.formValidate.attr.forEach(function (o, i) {
        // tmp['value' + i] = { title: o.attrName }
        // tmpTab['value' + i] = ''
        tmp[o.attrName] = {
          title: o.attrName
        };
        tmpTab[o.attrName] = '';
      });
      this.manyTabTit = tmp;
      this.manyTabDate = tmpTab;
      this.formThead = Object.assign({}, this.formThead, tmp);
    },
    handleRemove: function handleRemove(i) {
      this.formValidate.imagess.splice(i, 1);
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 点击商品图
    modalPicTap: function modalPicTap(tit, num, i) {
      var _this = this;
      this.$modalUpload(function (img) {
        if (tit === '1' && !num) {
          _this.formValidate.image = img[0].sattDir;
          _this.ManyAttrValue[0].image = img[0].sattDir;
        }
        if (tit === '2' && !num) {
          if (img.length > 10) return this.$message.warning("最多选择10张图片！");
          if (img.length + _this.formValidate.imagess.length > 10) return this.$message.warning("最多选择10张图片！");
          img.map(function (item) {
            _this.formValidate.imagess.push(item.sattDir);
          });
        }
        if (tit === '1' && num === 'duo') {
          _this.ManyAttrValue[i].image = img[0].sattDir;
        }
      }, tit, 'content');
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.formValidate.timeVal = e;
      this.formValidate.startTime = e ? e[0] : "";
      this.formValidate.stopTime = e ? e[1] : "";
    },
    changeGood: function changeGood() {
      var _this = this;
      this.$modalGoodList(function (row) {
        _this.formValidate.image = row.image;
        _this.productId = row.id;
        // _this.formValidate.productId = row.id
      });
    },
    handleSubmitNest1: function handleSubmitNest1() {
      if (!this.formValidate.image) {
        return this.$message.warning("请选择商品！");
      } else {
        this.currentTab++;
        if (!this.$route.params.id) this.getProdect(this.productId);
      }
    },
    // 商品分类；
    getCategorySelect: function getCategorySelect() {
      var _this3 = this;
      (0, _store.categoryApi)({
        status: -1,
        type: 1
      }).then(function (res) {
        _this3.merCateList = _this3.filerMerCateList(res);
      });
    },
    filerMerCateList: function filerMerCateList(treeData) {
      return treeData.map(function (item) {
        if (!item.child) {
          item.disabled = true;
        }
        item.label = item.name;
        return item;
      });
    },
    // 运费模板；
    getShippingList: function getShippingList() {
      var _this4 = this;
      (0, _logistics.shippingTemplatesList)(this.tempData).then(function (res) {
        _this4.shippingList = res.list;
      });
    },
    // 运费模板
    addTem: function addTem() {
      this.$refs.addTemplates.dialogVisible = true;
      this.$refs.addTemplates.getCityList();
    },
    // 商品详情
    getInfo: function getInfo() {
      if (!this.$route.params.id) {
        this.getProdect(this.productId);
      } else {
        this.getSekllProdect(this.$route.params.id);
      }
    },
    getProdect: function getProdect(id) {
      var _this5 = this;
      this.fullscreenLoading = true;
      (0, _store.productDetailApi)(id).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          var info;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                info = res;
                _this5.formValidate = {
                  image: _this5.$selfUtil.setDomain(info.image),
                  imagess: JSON.parse(info.sliderImage),
                  title: info.storeName,
                  info: info.storeInfo,
                  quota: '',
                  unitName: info.unitName,
                  sort: info.sort,
                  isShow: info.isShow,
                  tempId: info.tempId,
                  attr: info.attr,
                  attrValue: info.attrValue,
                  selectRule: info.selectRule,
                  content: info.content,
                  specType: info.specType,
                  productId: info.id,
                  giveIntegral: info.giveIntegral,
                  ficti: info.ficti,
                  timeId: _this5.$route.params.id ? Number(info.timeId) : _this5.$route.params.timeId ? Number(_this5.$route.params.timeId) : '',
                  startTime: info.startTime || '',
                  stopTime: info.stopTime || '',
                  timeVal: [],
                  status: 0,
                  num: 1
                };
                if (info.specType) {
                  _this5.$nextTick(function () {
                    info.attrValue.forEach(function (row) {
                      row.quota = row.stock;
                      row.attrValue = JSON.parse(row.attrValue);
                      for (var attrValueKey in row.attrValue) {
                        row[attrValueKey] = row.attrValue[attrValueKey];
                      }
                      row.image = _this5.$selfUtil.setDomain(row.image);
                      _this5.$refs.multipleTable.toggleRowSelection(row, true);
                      // this.$set(row, 'checked', true)
                    });
                  });
                  _this5.ManyAttrValue = info.attrValue;
                  _this5.multipleSelection = info.attrValue;
                } else {
                  info.attrValue.forEach(function (row) {
                    row.quota = row.stock;
                  });
                  _this5.ManyAttrValue = info.attrValue;
                  // this.formValidate.attr = []
                }
                _this5.fullscreenLoading = false;
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this5.fullscreenLoading = false;
      });
    },
    getSekllProdect: function getSekllProdect(id) {
      var _this6 = this;
      this.fullscreenLoading = true;
      (0, _marketing.seckillStoreInfoApi)({
        id: id
      }).then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
          var info;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                info = res;
                _this6.formValidate = {
                  image: _this6.$selfUtil.setDomain(info.image),
                  imagess: JSON.parse(info.sliderImage),
                  // title: info.title,
                  title: info.storeName,
                  // info: info.info,
                  info: info.storeInfo,
                  quota: info.quota,
                  unitName: info.unitName,
                  sort: info.sort,
                  isShow: info.isShow,
                  tempId: info.tempId,
                  attr: info.attr,
                  attrValue: info.attrValue,
                  selectRule: info.selectRule,
                  content: info.content,
                  specType: info.specType,
                  productId: info.productId,
                  giveIntegral: info.giveIntegral,
                  ficti: info.ficti,
                  timeId: Number(info.timeId),
                  // startTime: info.startTime || '',
                  startTime: info.startTimeStr || '',
                  // stopTime: info.stopTime || '',
                  stopTime: info.stopTimeStr || '',
                  status: info.status,
                  num: info.num,
                  timeVal: info.startTimeStr && info.stopTimeStr ? [info.startTimeStr, info.stopTimeStr] : [],
                  id: info.id
                };
                if (info.specType) {
                  _this6.ManyAttrValue = info.attrValue;
                  _this6.$nextTick(function () {
                    _this6.ManyAttrValue.forEach(function (item, index) {
                      item.attrValue = JSON.parse(item.attrValue);
                      for (var attrValueKey in item.attrValue) {
                        item[attrValueKey] = item.attrValue[attrValueKey];
                      }
                      item.image = _this6.$selfUtil.setDomain(item.image);
                      if (item.id) {
                        // 设置自动选中逻辑，只要id存在
                        _this6.$set(item, 'price', item.price);
                        _this6.$set(item, 'quota', item.quota);
                        _this6.$nextTick(function () {
                          _this6.$refs.multipleTable.toggleRowSelection(item, true);
                        });
                      }
                    });
                  });
                } else {
                  _this6.ManyAttrValue = info.attrValue;
                  // this.formValidate.attr = []
                }
                _this6.fullscreenLoading = false;
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this6.fullscreenLoading = false;
      });
    },
    handleSubmitNest2: function handleSubmitNest2(name) {
      var _this7 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (_this7.formValidate.specType && _this7.multipleSelection.length === 0) return _this7.$message.warning("请填选择至少一个商品属性！");
          _this7.currentTab++;
        } else {
          return false;
        }
      });
    },
    // 提交
    handleSubmit: (0, _validate.Debounce)(function (name) {
      var _this8 = this;
      if (!this.formValidate.specType) {
        // this.formValidate.attr = []
        this.formValidate.attrValue = this.ManyAttrValue;
      } else {
        // this.multipleSelection.forEach((row) => {
        //   this.$set(row, 'checked', true)
        // });
        this.formValidate.attrValue = this.multipleSelection;
      }
      this.formValidate.images = JSON.stringify(this.formValidate.imagess);
      this.formValidate.attrValue.forEach(function (item) {
        item.attrValue = JSON.stringify(item.attrValue);
      });
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this8.fullscreenLoading = true;
          _this8.loading = true;
          _this8.$route.params.id ? (0, _marketing.seckillStoreUpdateApi)({
            id: _this8.$route.params.id
          }, _this8.formValidate).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
            return _regenerator().w(function (_context3) {
              while (1) switch (_context3.n) {
                case 0:
                  _this8.fullscreenLoading = false;
                  _this8.$message.success('编辑成功');
                  _this8.$router.push({
                    path: "/marketing/seckill/list"
                  });
                  _this8.$refs[name].resetFields();
                  _this8.formValidate.images = [];
                  _this8.loading = false;
                case 1:
                  return _context3.a(2);
              }
            }, _callee3);
          }))).catch(function () {
            _this8.fullscreenLoading = false;
            _this8.loading = false;
          }) : (0, _marketing.seckillStoreSaveApi)(_this8.formValidate).then(/*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(res) {
              return _regenerator().w(function (_context4) {
                while (1) switch (_context4.n) {
                  case 0:
                    _this8.fullscreenLoading = false;
                    _this8.$message.success('新增成功');
                    _this8.$router.push({
                      path: "/marketing/seckill/list"
                    });
                    _this8.$refs[name].resetFields();
                    _this8.formValidate.images = [];
                    _this8.loading = false;
                  case 1:
                    return _context4.a(2);
                }
              }, _callee4);
            }));
            return function (_x3) {
              return _ref4.apply(this, arguments);
            };
          }()).catch(function () {
            _this8.fullscreenLoading = false;
            _this8.loading = false;
          });
        } else {
          if (!_this8.formValidate.storeName || !_this8.formValidate.unitName || !_this8.formValidate.store_info || !_this8.formValidate.image || !_this8.formValidate.images) {
            _this8.$message.warning("请填写完整商品信息！");
          }
        }
      });
    }),
    handleSubmitUp: function handleSubmitUp() {
      if (this.currentTab-- < 0) this.currentTab = 0;
    },
    setTagsViewTitle: function setTagsViewTitle() {
      var title = '编辑秒杀商品';
      var route = Object.assign({}, this.tempRoute, {
        title: "".concat(title, "-").concat(this.$route.params.id)
      });
      this.$store.dispatch('tagsView/updateVisitedView', route);
    },
    // 移动
    handleDragStart: function handleDragStart(e, item) {
      this.dragging = item;
    },
    handleDragEnd: function handleDragEnd(e, item) {
      this.dragging = null;
    },
    handleDragOver: function handleDragOver(e) {
      e.dataTransfer.dropEffect = 'move';
    },
    handleDragEnter: function handleDragEnter(e, item) {
      e.dataTransfer.effectAllowed = 'move';
      if (item === this.dragging) {
        return;
      }
      var newItems = _toConsumableArray(this.formValidate.imagess);
      var src = newItems.indexOf(this.dragging);
      var dst = newItems.indexOf(item);
      newItems.splice.apply(newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
      this.formValidate.imagess = newItems;
    }
  }
};